// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field } from 'redux-form';
import InputField from '../../customFields/InputField';

const fieldProps = {
  paddingBottomClassName: '',
  inputClassName: 'dashboard-input',
};

const Fee = () => {
  const handleChange = (event, newValue) => {
    if (Number.isNaN(Number(newValue))) event.preventDefault();
  };

  return (
    <div className="field_col">
      <label className="field_name" htmlFor="processingFee">
        Fee %
      </label>
      <Field
        id="processingFee"
        name="processingFee"
        component={InputField}
        type="text"
        placeholder="Fee"
        onChange={handleChange}
        {...fieldProps}
      />
    </div>
  );
};

export default Fee;
